import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import zxcvbn from 'zxcvbn';

import Bouton from '../../composant/UI/Bouton/Bouton';
import MdpMetre from '../../composant/UI/MdpMetre/MdpMetre';
import AttenteRequete from '../../hoc/AttenteRequete/AttenteRequete';
import * as actions from '../../services/actions';
import * as requestType from '../../ressources/glossaires/glossaire_requetes';
import * as s from '../../ressources/StyleGlobal/StyleGlobal';
import logoEntry from '../../ressources/Logo/argos_png_logo_white.png';
import styles from './ReinitialisationMDP.module.scss';
import { checkMot } from '../../ressources/functionJS/checkMot';
import { StatusIcon } from '../../composant/UI/Icons/StatusIcons';
import MessageErreur, {
  classeChampEnErreur,
} from '../../composant/UI/MessageErreur/MessageErreur';
import {
  schemaReinitialisationMotDePasse,
  estAssezFort,
} from '../../services/schemas/motDePasse';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../services/schemas/validerFormulaire';

const ReinitialisationMDP = () => {
  const dispatch = useDispatch();
  const codeVerifier = useSelector(
    (state) => state.authentifie.codeReinitialisationMDPVerifier
  );
  const reinitialisationMDPReussie = useSelector(
    (state) => state.authentifie.reinitialisationMDPReussie
  );

  const [nouveauMotDePasse, setNouveauMotDePasse] = useState('');
  const [confirmeNouveauMotDePasse, setConfirmeNouveauMotDePasse] =
    useState('');
  const [erreurs, setErreurs] = useState({});
  const [codeDeVerification, setCodeDeVerification] = useState('');

  useEffect(() => {
    // Get URL parameters
    const variableGet = window.location.href.split('?');
    if (variableGet.length > 1) {
      const listeVarible = variableGet[1].split('=');
      if (listeVarible.length === 2) {
        dispatch(actions.validationCodeVerification(listeVarible[1]));
        setCodeDeVerification(listeVarible[1]);
      }
    }
  }, [dispatch]);

  const handleNouveauMotDePasse = (event) => {
    setNouveauMotDePasse(event.target.value);
  };

  const handleConfirmeNouveauMotDePasse = (event) =>
    setConfirmeNouveauMotDePasse(event.target.value);

  // Calculée à chaque rendu : l'égalité n'était recalculée qu'à la frappe
  // dans la confirmation, et restait vraie après une modification du nouveau.
  const confirmationIdentique =
    confirmeNouveauMotDePasse !== '' &&
    confirmeNouveauMotDePasse === nouveauMotDePasse;

  const erreur = (champ) => messageDuChamp(erreurs, champ);
  const classeChamp = (champ) =>
    [
      s.form_control,
      styles.MotDePasse,
      erreur(champ) ? classeChampEnErreur : '',
    ].join(' ');

  const handleReinitialisationMDP = () => {
    const { valide, erreurs: nouvellesErreurs } = validerFormulaire(
      schemaReinitialisationMotDePasse,
      { nouveau: nouveauMotDePasse, confirmation: confirmeNouveauMotDePasse }
    );
    setErreurs(nouvellesErreurs);
    if (!valide) {
      return;
    }
    dispatch(
      actions.reinitialisationMDP(
        codeDeVerification,
        nouveauMotDePasse,
        confirmeNouveauMotDePasse
      )
    );
  };

  const fomulaireDeReinitialisation = (
    <>
      <h1 className={styles.TextTitre}>{checkMot('reinitialiser_mdptitre')}</h1>
      <form onSubmit={(event) => event.preventDefault()}>
        <div className={[s.form_group, s.row].join(' ')}>
          <label
            htmlFor="inputPassword"
            className={[s.col, s.col_form_label].join(' ')}
          >
            {checkMot('nouveau_mdp')}
          </label>
          <div className={[s.col_sm_11].join(' ')}>
            <input
              type="password"
              className={classeChamp('nouveau')}
              id="inputPassword"
              placeholder="nouveauMDP"
              value={nouveauMotDePasse}
              onChange={handleNouveauMotDePasse}
              autoComplete="new-password"
            />
            <MessageErreur cle={erreur('nouveau')} />
            <MdpMetre
              valeurForceMDP={zxcvbn(nouveauMotDePasse)}
              password={nouveauMotDePasse}
            />
          </div>
          <span className={[s.col_sm_1].join(' ')}>
            <StatusIcon condition={estAssezFort(nouveauMotDePasse)} />
          </span>
        </div>

        <div className={[s.form_group, s.row].join(' ')}>
          <label
            htmlFor="confirmPassword"
            className={[s.col, s.col_form_label].join(' ')}
          >
            {checkMot('confirmer_nouveau_mdp')}
          </label>
          <div className={[s.col_sm_11].join(' ')}>
            <input
              type="password"
              className={classeChamp('confirmation')}
              id="confirmPassword"
              placeholder="ConfirmerNouveauMDP"
              value={confirmeNouveauMotDePasse}
              onChange={handleConfirmeNouveauMotDePasse}
              autoComplete="new-password"
            />
            <MessageErreur cle={erreur('confirmation')} />
          </div>
          <span className={[s.col_sm_1].join(' ')}>
            <StatusIcon condition={confirmationIdentique} />
          </span>
        </div>

        <div className={styles.Bouton}>
          <AttenteRequete
            request_type={requestType.reinitialisation_du_mot_de_passe}
            str={checkMot('reinitialisation_en_cours')}
          >
            <Bouton cliquer={handleReinitialisationMDP}>
              {checkMot('reinitialiser_le_mot_de_passe')}
            </Bouton>
          </AttenteRequete>
        </div>
      </form>
    </>
  );

  const formulaireDeReinitialisationValide = (
    <div className={styles.FormulaireReinitialisation}>
      <h4 className={styles.TextTitre}>
        {checkMot(
          'votre_mot_de_passe_a_ete_reinitialise_retournez_sur_la_page_d_accueil_pour_vous_connecter'
        )}
      </h4>
      <Link to={'/'}>{checkMot('page_de_connexion')}</Link>
    </div>
  );

  const codeNonVerifier = (
    <div className={styles.FormulaireReinitialisation}>
      <h4 className={styles.TextTitre}>
        {checkMot('code_de_verification_ou_lien_incorrecte')}
      </h4>
    </div>
  );

  return (
    <div className={styles.PageAccueilConnexion}>
      <img alt="logo" src={logoEntry} />
      {codeVerifier
        ? reinitialisationMDPReussie
          ? formulaireDeReinitialisationValide
          : fomulaireDeReinitialisation
        : codeNonVerifier}
    </div>
  );
};

export default ReinitialisationMDP;
